import { render } from "./iconPage.vue?vue&type=template&id=3837118c"
import script from "./iconPage.vue?vue&type=script&lang=js"
export * from "./iconPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__